import React from 'react';
import { HtmlField, TextField } from 'framework/ui/field';
import { Grid2 as Grid } from '@mui/material';

interface NameDescriptionFieldProps {
  value?: any;
}

const NameDescriptionField = ({ value }: NameDescriptionFieldProps) => {
  const { name, description } = value;

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 12, xl: 3 }}>
        <TextField value={name} />
      </Grid>
      <Grid size={{ xs: 12, md: 12, xl: 9 }}>
        <HtmlField value={description} />
      </Grid>
    </Grid>
  );
};

export default NameDescriptionField;
